import { cn } from "../../../lib/cn";

/**
 * TypePill — selector grande para "Incidencias / Sugerencias"
 * estilo segmented pill.
 *
 * Uso:
 *   <TypePillGroup>
 *     <TypePill active={tipo === 'inc'} icon={...} label="Incidencias"
 *       count={12} onClick={() => setTipo('inc')} />
 *     <TypePill active={tipo === 'sug'} icon={...} label="Sugerencias"
 *       count={5} onClick={() => setTipo('sug')} />
 *   </TypePillGroup>
 */

export function TypePillGroup({ children, className }) {
  return (
    <div className={cn(
      "inline-flex items-center gap-1 p-1 rounded-lg bg-slate-100",
      className,
    )}>
      {children}
    </div>
  );
}

export function TypePill({ active, icon, label, count, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-2 px-4 py-2 rounded-md",
        "text-sm font-medium transition-all",
        active
          ? "bg-white text-slate-900 shadow-sm"
          : "text-slate-500 hover:text-slate-700",
      )}
    >
      {icon}
      <span>{label}</span>
      {typeof count === "number" && (
        <span className="text-xs text-slate-400">{count}</span>
      )}
    </button>
  );
}
